module.exports = __webpack_public_path__ + "static/media/gear.b1137265.svg";